module.exports = __webpack_public_path__ + "img/back.52fd9e50.svg";